export const identity = {
  identityFormTitle: "Complete your details",
  identityFormDescription: "Enter your ID document to continue.",
  identityFormSubmit: "Continue",
  identityFormSave: "Save and continue",
  identityFormVerifying: "Checking...",
  identityFormSaving: "Saving...",
  identityFormErrorTitle: "Could not complete",
  identityCedulaLabel: "ID type and number",
  identityIdTypeLabel: "ID type",
  identityCedulaRequired: "Enter your document number",
  identityCedulaLength: "Must contain between 6 and 10 digits",
  identityRutPlaceholder: "12345678-9",
  identityRutRequired: "Enter your Chilean RUT",
  identityRutInvalid: "Enter a valid Chilean RUT (format: 12345678-9)",
  identityFirstNameLabel: "First name",
  identityFirstNamePlaceholder: "Your first name",
  identityFirstNameRequired: "Enter your first name",
  identityLastNameLabel: "Last name",
  identityLastNamePlaceholder: "Your last name",
  identityLastNameRequired: "Enter your last name",
  identityBirthdateLabel: "Date of birth",
  identityBirthdatePlaceholder: "Select your date of birth",
  identityBirthdateRequired: "Enter your date of birth",
  identityManualFallbackHint:
    "We could not verify your ID automatically. Please complete your details manually to continue.",
  identityChangeCedula: "Change ID",
  identityVerifiedLabel: "ID verified",

  identityError_generic: "We could not complete your registration. Please try again.",
  identityError_invalid_document: "The document format is not valid.",
  identityError_underage: "You must be at least 18 years old to register.",
  identityError_document_not_found: "We could not find your ID in the civil registry.",
  identityError_document_already_registered: "This ID is already registered. Log in with your existing account.",
  identityError_verification_expired: "Verification expired. Please enter your ID again.",
  identityError_verification_invalid: "Verification is not valid. Please enter your ID again.",
  identityError_verification_required: "You must verify your ID before continuing with Google.",
  identityError_kyc_unavailable: "The verification service is unavailable. Please try later.",
  identityError_rate_limit_exceeded: "Too many attempts. Wait a few minutes and try again.",

  onboardingModalTitle: "Complete your profile",
  onboardingContinue: "Continue",
  onboardingBack: "Back",
  onboardingLater: "I'll do it later",
  onboardingConfirm: "Confirm and save",
  onboardingPagoMovilTitle: "Pago Móvil",
  onboardingPagoMovilDescription: "Add your bank and phone for bolívar deposits and withdrawals.",
  onboardingPhoneDigits: "Enter the remaining 7 phone digits",
  onboardingSuccessTitle: "Profile completed",
  onboardingSuccessMessage: "Your identity and Pago Móvil account are set up.",
  onboardingSuccessProfileOnly: "Your details were saved successfully.",
  onboardingErrorTitle: "Could not complete registration",
  onboardingErrorMessage: "Check your details and try again.",
  onboardingReferralWarningTitle: "Referral code not applied",
};
